import qs from 'qs'
import request from '../utils/request'
export default {
    /**---------------------------------公用接口---------------------------------------*/
    //获取菜单接口
    //查询物料中心列表
    getUserMenu({account}) {
        return request({
            method: 'GET',
            url: `/external-common/users/${account}/apps/budget/menu?resourceCode=budget`
        })
    },
    //获取用户操作权限
    getUserAction({account, code}) {
        return request({
            method: 'GET',
            url: `/external-common/users/${account}/apps/budget/action?resourceCode=${code}`
        })
    },
    getDataInit() {
        return request({
          url: `/mm/material/getDataInit`,
        })
      }
}
